// axiosInstance.js

import axios from 'axios';
import { BASE_URL, BASE_URL2 } from './axios';

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});
const axiosInstance2 = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'multipart/form-data',
  },
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});

export  {axiosInstance
  ,axiosInstance2
};
